import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Fa from 'react-fontawesome';
import { each, reduce } from 'lodash';

import { connect } from 'react-redux';
import { Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';


import DateTimeDisplay from '../../../../components/date-time-display';
import { winLossLoadContactDispositions } from '../../WinLossActions';
import { getIndexedContacts, getIndexedOpportunities } from '../../WinLossReducer';

const headerHeight = 40;
const rowHeight = 40;


class DispositionModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: {
      },
    };
    this.close = this.close.bind(this);
    this.handleRowClick = this.handleRowClick.bind(this);
  }

  close() {
    this.props.onClose();
  }

  handleRowClick(contact) {
    const { opportunityId, program, indexedOpportunities } = this.props;
    const opportunity = opportunityId ? indexedOpportunities[opportunityId] : null;
    if (!opportunity) {
      return;
    }
    const tracking = opportunity ? opportunity.tracking || {} : {};
    const oppId = tracking.tv__opportunityId; // or sfa__opportunityId
    const contactId = contact.tv__contactId; // or sfa__contactId
    if (!oppId || !contactId) {
      return;
    }
    const clientId = program.client_id;
    const { expanded } = this.state;
    const isExpanded = expanded[contactId] === true;
    const newExpanded = { ...expanded, [contactId]: !isExpanded };
    this.setState({ expanded: newExpanded });
    const { activities } = contact;
    if (!activities) {
      this.props.dispatch(winLossLoadContactDispositions(clientId, oppId, contactId));
    }
  }


  renderActivities(activities) {
    return (
      <div style={{ backgroundColor: '#fff', padding: 10 }}>
        <table style={{ margin: 0 }} className="table table-condensed table-bordered table-striped">
          <thead>
            <tr>
              <th>Disposition Name</th>
              <th width="150" >Date</th>
              <th width="100" className="text-right">Disposition</th>
            </tr>
          </thead>
          <tbody>
            {activities.map((activity) => {
              const hasNote = activity.notes && activity.notes.length > 0;
              const tip = hasNote ? (<Tooltip id={`name-${activity.completed}`}><div>{activity.notes}</div></Tooltip>) : null;

              return (
                <tr key={activity.completed}>
                  <td>
                    {hasNote &&
                      <OverlayTrigger placement="top" overlay={tip}>
                        <span>{activity.dispositionName}</span>
                      </OverlayTrigger>
                    }
                    {!hasNote && <div>{activity.dispositionName}</div>}
                  </td>
                  <td><DateTimeDisplay value={activity.completed} format="short" /></td>
                  <td className="text-right">{activity.disposition}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }

  render() {
    const {
      isOpen, opportunityId, indexedContacts, indexedOpportunities,
    } = this.props;
    const { expanded } = this.state;
    const opportunity = opportunityId ? indexedOpportunities[opportunityId] : null;
    const hasData = opportunity !== null && opportunity !== undefined;
    let tracking = {};
    if (hasData) {
      tracking = opportunity.tracking || {};
    }
    const contacts = [];
    if (isOpen) {
      each(tracking.contacts, (contact) => {
        const id = contact.sfa__contactId;
        const isExpanded = expanded[contact.tv__contactId];
        let height = rowHeight;
        if (isExpanded) {
          if (contact.activities && contact.activities.status === 'loaded') {
            height = rowHeight + (contact.activities.activities.length * rowHeight) + headerHeight + 2;
          } else if (contact.activities && contact.activities.status === 'error') {
            height = rowHeight * 2.5;
          }
        }
        if (indexedContacts[id]) {
          contacts.push({
            ...indexedContacts[id],
            ...contact,
            height,
            isExpanded,
          });
        }
      });
    }
    const sortedData = contacts;
    return (
      <Modal bsSize="lg" show={isOpen} onHide={this.close}>
        {hasData &&
          <div>
            <Modal.Header closeButton>
              <Modal.Title>{tracking.sfa__opportunityName}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div>
                {contacts.length === 0 && <div>No records found.</div>}
                {contacts.length !== 0 &&
                  <div>
                    <table className="table table-bordered table-condensed table-striped">
                      <thead>
                        <tr>
                          <th width="30">&nbsp;</th>
                          <th width="99%">Contact</th>
                          <th>Last&nbsp;Activity</th>
                        </tr>
                      </thead>
                      <tbody>
                        {sortedData.map((contact) => {
                          const { isExpanded, activities, lastActivity } = contact;
                          const hasLastActivities = lastActivity !== null && lastActivity !== undefined;
                          const name = `${contact.first_name} ${contact.last_name}`;
                          const click = (e) => {
                            e.preventDefault();
                            this.handleRowClick(contact);
                          };
                          const rows = [];
                          rows.push((
                            <tr key={`${contact._id}-upper`}>
                              <td className="text-center" onClick={click} style={{ cursor: hasLastActivities ? 'pointer' : 'not-allowed' }}>
                                {hasLastActivities &&
                                  <div>
                                    {!isExpanded && <Fa name="plus-square-o" />}
                                    {isExpanded &&
                                      <div>
                                        {activities &&
                                          <div>
                                            {activities.status === 'loading' && <Fa name="spinner" spin />}
                                            {activities.status !== 'loading' && <Fa name="minus-square-o" />}
                                          </div>
                                        }
                                        {!activities && <Fa name="minus-square-o" />}
                                      </div>
                                    }
                                  </div>
                                }
                                {!hasLastActivities && <Fa name="plus-square-o" className="invisible" />}
                              </td>
                              <td>
                                {hasLastActivities && <a href="" onClick={click}>{name}</a>}
                                {!hasLastActivities && <span>{name}</span>}
                              </td>
                              <td>
                                {hasLastActivities && <nobr><DateTimeDisplay value={lastActivity.completed} format="shortWithTime" /></nobr>}
                                {!hasLastActivities &&
                                  <div>
                                    {!contact.rejected && <div>Pending</div>}
                                    {contact.rejected && <div>Rejected</div>}
                                  </div>
                                }
                              </td>
                            </tr>
                          ));
                          if (isExpanded) {
                            rows.push((
                              <tr key={`${contact._id}-lower`}>
                                <td colSpan={3}>
                                  {isExpanded && activities.status === 'loaded' && this.renderActivities(activities.activities)}
                                  {isExpanded && activities.status === 'error' &&
                                    <div className="alert alert-danger">
                                      {activities.errors.message}
                                    </div>
                                  }
                                </td>
                              </tr>
                            ));
                          }
                          return rows;
                        })}
                      </tbody>
                    </table>
                  </div>
                }
              </div>
            </Modal.Body>
          </div>}
        {!hasData && <div />}
      </Modal>
    );
  }
}

DispositionModal.propTypes = {
  dispatch: PropTypes.func.isRequired,
  onClose: PropTypes.func,
  isOpen: PropTypes.bool.isRequired,
  opportunityId: PropTypes.string,
  program: PropTypes.shape({}).isRequired,
  indexedContacts: PropTypes.shape({}),
  indexedOpportunities: PropTypes.shape({}),
};
DispositionModal.defaultProps = {
  onClose: () => {},
  indexedContacts: {},
  indexedOpportunities: {},
  opportunityId: null,
};


function mapStateToProps(state) {
  return {
    indexedContacts: getIndexedContacts(state),
    indexedOpportunities: getIndexedOpportunities(state),
  };
}

export default connect(mapStateToProps)(DispositionModal);
